<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goBack()">{{ 'customerUpdate.buttons.back' | translate }}</button>
    </app-page-header>
    <div class="setting-data">
      <div class="second-headboard">
        <h1>{{ 'customerUpdate.title' | translate }}</h1>
        <!-- <img src="../../assets/icons/1234.png" alt="logo de Billcentrix"> -->

      </div>
      <div class="general-data">
        <h1>{{ 'customerUpdate.generalData' | translate }}</h1>
        <form [formGroup]="form">
          <div class="items code-row">
            <label for="code_customer">{{ 'customerUpdate.fields.code' | translate }}*</label>
            <input id="code_customer" [formControl]="form.controls['code_customer']" type="text"
              [placeholder]="'customerUpdate.fields.codePlaceholder' | translate">
            <small class="code-hint">{{ 'customerUpdate.fields.codeHint' | translate }}</small>
            @if (form.controls['code_customer'].hasError('required') && form.controls['code_customer'].touched) {
              <small class="form-error-msg">{{ 'customerUpdate.fields.codeRequired' | translate }}</small>
            }
          </div>
          <div class="grid">
            <div class="left">
              <div class="items">
                <label for="name">{{ 'customerUpdate.fields.name' | translate }}*</label>
                <input [formControl]="form.controls['name_customer']"
                  type="text">
                  @if (form.controls['name_customer'].hasError('required') &&
                    form.controls['name_customer'].touched) {
                    <small
                    class="form-error-msg"> {{ 'customerUpdate.fields.nameError' | translate }} </small>
                  }
                </div>


            <div class="items">
              <label for="email">{{ 'customerUpdate.fields.email' | translate }}*</label>
              <input [formControl]="form.controls['email_customer']" type="text">
              @if (form.controls['email_customer'].hasError('required') && form.controls['email_customer'].touched) {
                <small
                  class="form-error-msg"> {{ 'customerUpdate.fields.emailError' | translate }}
                </small>
              }
            </div>

            <div class="items">
              <label for="phone">{{ 'customerUpdate.fields.phone' | translate }}</label>
              <input id="phone" (keypress)="onlyNumberKey($event)" [formControl]="form.controls['phoneNumber_customer']" type="tel" inputmode="numeric" maxlength="14" autocomplete="tel">
              @if (form.controls['phoneNumber_customer'].hasError('pattern') && form.controls['phoneNumber_customer'].touched) {
                <small
                class="form-error-msg"> {{ 'customerUpdate.fields.phoneInvalid' | translate }} </small>
              }
            </div>

          </div>
          <div class="right">
            <div class="items">
              <label for="address">{{ 'customerUpdate.fields.lastName' | translate }}*</label>
              <input [formControl]="form.controls['lastName_customer']" type="text">
              @if (form.controls['lastName_customer'].hasError('required') && form.controls['lastName_customer'].touched) {
                <small
                class="form-error-msg"> {{ 'customerUpdate.fields.lastNameError' | translate }} </small>
              }
            </div>
            <div class="items">
              <label for="address">{{ 'customerUpdate.fields.dni' | translate }}*</label>
              <input [formControl]="form.controls['identifier_customer']" type="text">
              @if (form.controls['identifier_customer'].hasError('required') && form.controls['identifier_customer'].touched) {
                <small
                class="form-error-msg"> {{ 'customerUpdate.fields.dniError' | translate }} </small>
              }
              @if (form.controls['identifier_customer'].hasError('pattern') && form.controls['identifier_customer'].touched) {
                <small
                class="form-error-msg"> {{ 'customerUpdate.fields.dniInvalid' | translate }} </small>
              }
            </div>

          </div>
        </div>
      </form>
    </div>
    <div style="padding-top: 2em;">
      <h1>{{ 'customerUpdate.addresses.title' | translate }}</h1>
      <mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="suscription">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerUpdate.addresses.columns.subscription' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="id"> {{ row.plan.name_plan }}</mat-cell>
        </ng-container>


        <ng-container matColumnDef="adress">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerUpdate.addresses.columns.address' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" data-label="adress"> {{ row?.address.adress }}</mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="corregimiento">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Corregimiento</mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="corregimiento"> {{ row.address.corregimiento.name }}
        </mat-cell>
      </ng-container>


      <ng-container matColumnDef="province">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Provincia</mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="province"> {{ row.address.province.name }}</mat-cell>
      </ng-container> -->


      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerUpdate.addresses.columns.actions' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="estatus">
          <button mat-icon-button [matMenuTriggerFor]="msgMenu" (click)="$event.stopPropagation()"
            class="hidden-on-open">
            <mat-icon class="text-muted">more_vert</mat-icon>
          </button>
          <mat-menu style="width: 200px;" #msgMenu="matMenu">
            <button mat-menu-item (click)="updateAddress(row)" class="menu_report"><img
              src="../assets/icons/update.svg"> {{ 'customerUpdate.addresses.menu.edit' | translate }}
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>
    <mat-paginator showFirstLastButtons
      [length]="tableService.pager.totalEntities"
      [pageIndex]="tableService.pager.pageIndex"
      [pageSize]="tableService.pager.pageSize"
      [pageSizeOptions]="[20, 50, 100]"
      >
    </mat-paginator>
  </div>
</div>


<div class="options-buttons">
  <button class="back-btn" (click)="goBack()">{{ 'customerUpdate.buttons.cancel' | translate }}</button>
  <button class="continue-btn" (click)="update()">{{ 'customerUpdate.buttons.save' | translate }}</button>
</div>
</div>
</body>
